import { useTranslation } from 'react-i18next';

import { Modal } from '@thinknet-gmbh/platform-common-ui';

import { DocumentViewer } from 'src/components/document-viewer';
import { useGetDocumentTemplatePdfPreviewById } from 'src/hooks/documents-templates/get-document-template-preview-file.hook';

interface IPreviewDocumentTemplateModal {
  documentTemplateId: string;
  employeeId?: string;
  onClose: () => void;
  isMemberOwnDoc: boolean;
}

const PreviewDocumentTemplateModal = ({
  documentTemplateId,
  employeeId,
  onClose,
  isMemberOwnDoc,
}: IPreviewDocumentTemplateModal) => {
  const { t } = useTranslation(['common', 'vacancies']);

  const { loading, pdfBase64 } = useGetDocumentTemplatePdfPreviewById(
    documentTemplateId,
    employeeId,
    isMemberOwnDoc
  );

  return (
    <Modal isOpened onClose={onClose} title={t('vacancies:labels.documentView')} modalWidth={1000}>
      <DocumentViewer base64={pdfBase64} loading={loading} />
    </Modal>
  );
};

export default PreviewDocumentTemplateModal;
